module.exports = __webpack_public_path__ + "static/img/1.69efc030.png";